import React, { useMemo } from "react";
import { Select } from "@coolremote/shared";
import useStyles from "./MenuDropDown.style";
import { Arrow } from "../../icons/";

const MenuDropDown = (props: any) => {
  const classes = useStyles();
  const { value, options, onChange, disableNotAllowed = false, hideArrow = false, disabled = false } = props;
  
  // Memoize mapped options to prevent unnecessary re-renders in the Select component
  const optionsStr = JSON.stringify(options);
  const mappedOptions = useMemo(() => {
    return (options ?? []).map((option: any) => ({ value: option.value, label: option.name }));
  }, [optionsStr]);

  return (
    <Select
      menuSearch
      menuPortal
      preventBlurOnSelect
      value={value}
      onChange={onChange}
      className={classes.selectContainer}
      classes={{ trigger: classes.selectStyle, menu: classes.menuStyle, option: classes.optionStyle }}
      arrowIcon={Arrow}
      disabled={(!disableNotAllowed && options?.length === 1) || disabled}
      options={mappedOptions}
    />
  );
};

export default MenuDropDown;
